var particle_pointAlongVS = `
	inAngle = atan(velocityV.x, velocityV.y);
`;

export { particle_pointAlongVS as default };
